import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { OrderLine, OrderModel } from 'src/app/models/order.model';
import { Good } from 'src/app/models/sync.model';
import {
  QuantityDialogData,
  QuantityDialogPlainComponent,
} from '../quantity-dialog/quantity-dialog.component';
import { CurrentOrderService } from 'src/app/services/data/current-order.service';
import { MatDialog } from '@angular/material/dialog';
import { Subject, SubscriptionLike } from 'rxjs';
import { ErpPrice } from 'src/app/models/goods/product';
import { CurrentRefundService } from 'src/app/services/data/current-refund.service';
import { RefundModel } from 'src/app/models/refund.model';
import { BPPriceType } from 'src/app/models/client.model';

@Component({
  selector: 'app-edit-order-select-goods-item',
  templateUrl: './edit-order-select-goods-item.component.html',
  styleUrls: ['./edit-order-select-goods-item.component.scss'],
})
export class EditOrderSelectGoodsItemComponent implements OnInit, OnDestroy {
  @Input() item!: Good;
  @Input() priceTypes: BPPriceType[] | undefined;
  orderId: string | undefined;
  refundId: string | undefined;

  protected ngUnsubscribe: Subject<void> = new Subject<void>();
  subscriptions: SubscriptionLike[] = [];

  /**
   *
   */
  constructor(
    public dialog: MatDialog,
    public currentOrder: CurrentOrderService,
    private currentRefund: CurrentRefundService
  ) { }

  ngOnInit(): void {

    if (this.item.rests !== undefined && this.item.rests?.length) {
      this.item.displayRest = this.item.rests[0].quantity;
    } else {
      this.item.displayRest = 0;
    }

    this.initPrice();

    const sq1 = this.currentOrder.orderInfo$.subscribe({
      next: (o) => {
        // if (this.item && this.item.codeExch === 'L4994') {
        //   console.log(o?.id);
        // }

        if (!o) return;
        this.orderId = o.id;

        this.mapOrdered(o);
      },
    });

    const sq2 = this.currentOrder.prices$.subscribe({
      next: (p) => {
        this.mapPrices(p);
      },
    });

    const sq3 = this.currentRefund.return$.subscribe({
      next: r => {
        if (!r) return
        this.refundId = r.id;
        this.mapRefunded(r);

      }
    })

    this.subscriptions.push(sq1, sq2, sq3);
  }
  initPrice() {

    this.item.displayPrice = 0;

    if (
      !this.item ||
      !this.item.prices ||
      Object.keys(this.item.prices).length <= 0 ||
      !this.priceTypes ||
      this.priceTypes.length <= 0
    ) {
      return;
    }

    //    const targetT = this.priceTypes[0].priceTypeCode;

    let targetT = this.priceTypes.find(c => c.goodTypeId == this.item.goodTypeCode)
    if (!targetT) {
      targetT = this.priceTypes.find(c => !c.goodTypeId)
    }


    if (targetT && this.item.prices[targetT.priceTypeCode]) {
      this.item.displayPrice = this.item.prices[targetT.priceTypeCode];
    }



  }

  mapPrices(p: ErpPrice | undefined) {
    if (!this.item) {
      return
    }
    const current = p?.items.find((a) => a.goodId == this.item.code);
    if (!current) return;

    if (Math.abs(this.item.displayPrice - (current.price ?? 0)) > 0.01) {
      this.item.displayClientPrice = current.price;
    }
    this.item.displaySalePrice = current.salePrice;
  }

  mapOrdered(orderInfo: OrderModel) {
    const inOrder = orderInfo?.items.find((a) => a.goodId === this.item.code);

    if (!inOrder) {
      this.item.ordered = undefined;
    } else {
      this.item.ordered = inOrder.amount;
    }
  }

  mapRefunded(refindInfo: RefundModel) {
    const inRefund = refindInfo?.items?.find((a) => a.goodId === this.item.code);

    if (!inRefund) {
      this.item.inRefund = undefined;
    } else {
      this.item.inRefund = inRefund.amount;
    }
  }

  clickOnItem(item: Good) {
    if (!this.orderId && !this.refundId) {
      return;
    }

    let price = this.item.displayPrice;

    // перетираем цену по типу - персональной ценой
    if (
      this.item.displayClientPrice !== undefined &&
      this.item.displayClientPrice > 0
    ) {
      price = this.item.displayClientPrice;
    }

    // перетираем персональную цену акционной ценой
    if (
      this.item.displaySalePrice !== undefined &&
      this.item.displaySalePrice > 0

    ) {
      price = this.item.displaySalePrice;
    }

    // отсутствие цены - ошибка. но агент должен иметь возможность сделать заказ.
    if (this.item.displayRest > 0) {
      const dd = {
        line: {
          price: price,
          goodId: item.code,
          good: item.name,
          orderId: this.orderId,
          amount: this.orderId ? item.ordered : item.inRefund,
        } as OrderLine,

        ok: false,
        ignoreMinPart: this.refundId ? true : false,
        canDeleteItem: this.orderId ? !!item.ordered : !!item.inRefund,
        isOrder: this.refundId ? false : true
      } as QuantityDialogData;

      this.openDialog(dd);
    }
  }

  openDialog(dd: QuantityDialogData): void {
    const dialogRef = this.dialog.open(QuantityDialogPlainComponent, {
      width: '600px',
      data: dd,
    });

    dialogRef.afterClosed().subscribe((result: QuantityDialogData) => {

      if (
        result?.line != undefined &&
        result.line.amount != undefined &&
        result.line.amount > 0 &&
        result.ok
      ) {
        if (this.orderId) {
          this.currentOrder.addOrUpdateItem(result.line);
        }
        if (this.refundId) {
          //  console.log(result.line)
          this.currentRefund.addOrUpdateItem(result.line)
        }
      }
    });
  }

  public deleteItem(itemId: string): void {
    if(this.orderId){
      this.currentOrder.deleteItem(itemId)
    }
    if(this.refundId){
      this.currentRefund.deleteItem(itemId)
    }
  }
  

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.subscriptions = [];
  }
}
